import { Box, alpha, Popover, styled } from "@mui/material";
import { Primary } from '../../../core-components/theme/color-palette/colors';

export const communicationItemStyles = {
    p: 3,
    border: '1px solid ',
    borderColor: '#BDBDBD',
    position: 'relative',
    borderRadius: 2,
    backgroundColor: '#fff',
    boxShadow:'none',
    marginBottom: 3,
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      bgcolor: 'action.selected',
    },
    transition: 'background-color 0.2s ease',
  };

  export const badgeStyle = {
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  };

  export const borderAnimation = `
  @keyframes rotate-border {
    100% { transform: rotate(360deg); }
  }`;


   export const listContainerStyles = {
    display: 'flex',
    flexDirection: 'column',
    p: 1,
};

 export const loadingContainerStyles = {
    display: 'flex',
    flexDirection: 'column',
};

 export const skeletonItemStyles = {
    py: 2,
    // borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    // gap: 2,
    width: '100%',
};

 export const errorContainerStyles = {
    p: 4,
    textAlign: 'center',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

 export const emptyContainerStyles = {
    p: 4,
    textAlign: 'center',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};

 export const bottomIndicatorStyles = {
    // p: 2,.
    pr:"2px",
    textAlign: 'center',
};

 export const endMessageStyles = {
    textAlign: 'center',
    p: 2,
};


export const StyledPopover = styled(Popover)(({ theme }) => ({
    '& .MuiPopover-paper': {
        width: 600,
        height: '75vh',
        maxWidth: '100%',
        maxHeight: '80%',
        borderRadius: theme.spacing(2),
        boxShadow: 'none',
        border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
        padding: 10,
        backgroundColor: '#FAFAFA',
        [theme.breakpoints.down('sm')]: {
            width: '92vw',
            padding: 3
        },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
    },
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

export const ContentBox = styled(Box)(({ theme }) => ({
    marginTop: '10px',
    maxHeight: 'calc(75vh - 110px)',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: 0,
        background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        background: theme.palette.divider,
        borderRadius: 4,
    },
}));

export const tabStyles = {
    display: 'flex',
    justifyContent: 'center',
    minHeight: 48,
    '& .MuiTabs-flexContainer': {
        justifyContent: 'center',
    },
    '& .MuiTabs-indicator': {
        backgroundColor: Primary[700],
        height: 2,
    },
    '& .MuiTab-root': {
        textTransform: 'none',
        fontWeight: 500,
        color: 'text.secondary',
        transition: 'all 0.2s ease-in-out',
        textAlign: 'center',
        '&.Mui-selected': {
            color: Primary[700],
            fontWeight: 600,
        },
        '&:hover': {
            color: Primary[700],
        },
    },
};

export const headerButtonSx = {
    minWidth: 'auto',
    p: 0.5,
    ml: 1,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: 'action.hover',
        transform: 'scale(1.05)',
    },
};